import React, { useState } from 'react';
import { FaBars, FaTimes } from 'react-icons/fa';
import { MdKeyboardArrowRight, MdKeyboardArrowDown } from 'react-icons/md';
import { Link } from 'react-router-dom';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [expandedSection, setExpandedSection] = useState(null); // Tracks which section is expanded

  const toggleMenu = () => setIsMenuOpen((prev) => !prev);

  const toggleSection = (section) => {
    setExpandedSection((prev) => (prev === section ? null : section)); // Toggle only one section at a time
  };

  return (
    <nav className="bg-gray-800 text-white p-4">
      <div className="flex justify-between items-center">
        {/* Logo */}
        <div className="flex items-center">
          <img
            src="/SmartAuditx_Logo.png"
            alt="SMARTAUDITX Logo"
            className="h-10 w-10 object-contain mr-2"
          />
          <h1 className="text-lg font-bold">SmartAuditX</h1>
        </div>

        {/* Hamburger Icon */}
        <button
          className="block sm:hidden focus:outline-none"
          onClick={toggleMenu}
          aria-label="Toggle Menu"
        >
          {isMenuOpen ? <FaTimes className="text-2xl" /> : <FaBars className="text-2xl" />}
        </button>

        {/* Main Menu (Desktop) */}
        <ul className="hidden sm:flex space-x-8">
          <li>
            <Link to="/" className="hover:underline">
              Home
            </Link>
          </li>

          {/* Resources Dropdown */}
          <li className="relative group">
            <button
              className="flex items-center space-x-2 hover:underline"
              onClick={() => toggleSection('resources')}
            >
              <span>Resources</span>
              <span>
                {expandedSection === 'resources' ? <MdKeyboardArrowDown /> : <MdKeyboardArrowRight />}
              </span>
            </button>
            <ul
              className={`absolute left-0 mt-2 bg-gray-700 text-white rounded-md shadow-lg ${
                expandedSection === 'resources' ? 'block' : 'hidden'
              }`}
            >
             
          
              <li className="px-4 py-2 hover:bg-gray-600">
                <Link to="/resources/audit-frameworks">Audit Frameworks</Link>
              </li>
              <li className="px-4 py-2 hover:bg-gray-600">
                <Link to="/resources/workprograms">Work Programs</Link>
              </li>
              <li className="px-4 py-2 hover:bg-gray-600">
                <Link to="/resources/risk-matrix">Risk and Control Matrix</Link>
              </li>
              <li className="px-4 py-2 hover:bg-gray-600">
                <Link to="/resources/audit-templates">Audit Templates</Link>
              </li>
              <li className="px-4 py-2 hover:bg-gray-600">
                <Link to="/resources/job-descriptions">Job Descriptions</Link>
              </li>

              <li className="px-4 py-2 hover:bg-gray-600">
                <Link to="/resources/risk-library">Business Cycle Risks Library</Link>
              </li>

              <li className="px-4 py-2 hover:bg-gray-600">
                <Link to="/resources/guided-toolkit">Guided Toolkits</Link>
              </li>



            </ul>
          </li>

           {/* Learning Dropdown */}
         <li className="relative group">
            <button
              className="flex items-center space-x-2 hover:underline"
              onClick={() => toggleSection('learning')}
            >
              <span>Learning</span>
              <span>
                {expandedSection === 'learning' ? <MdKeyboardArrowDown /> : <MdKeyboardArrowRight />}
              </span>
            </button>
            <ul
              className={`absolute left-0 mt-2 bg-gray-700 text-white rounded-md shadow-lg ${
                expandedSection === 'learning' ? 'block' : 'hidden'
              }`}
            >
              <li className="px-4 py-2 hover:bg-gray-600">
                <Link to="/videos">Videos</Link>
              </li>
              <li className="px-4 py-2 hover:bg-gray-600">
                <Link to="/podcasts">Podcasts</Link>
              </li>
              <li className="px-4 py-2 hover:bg-gray-600">
                <Link to="/faqs">Frequently Asked Questions</Link>
              </li>      
              <li className="px-4 py-2 hover:bg-gray-600">
                <Link to="/gamified-learning">Gamified Learning</Link>
              </li>

          
            </ul>
          </li>

          
           {/* Continuous Dropdown */}
         <li className="relative group">
            <button
              className="flex items-center space-x-2 hover:underline"
              onClick={() => toggleSection('continuous')}
            >
              <span>Continuous Auditing</span>
              <span>
                {expandedSection === 'continuous' ? <MdKeyboardArrowDown /> : <MdKeyboardArrowRight />}
              </span>
            </button>
            <ul
              className={`absolute left-0 mt-2 bg-gray-700 text-white rounded-md shadow-lg ${
                expandedSection === 'continuous' ? 'block' : 'hidden'
              }`}
            >
              <li className="px-4 py-2 hover:bg-gray-600">
                <Link to="/continuous">Dashboards</Link>
              </li>
   
          
            </ul>
          </li>

          {/* AI Tools */}
          <li className="relative group">
            <button
              className="flex items-center space-x-2 hover:underline"
              onClick={() => toggleSection('aiTools')}
            >
              <span>AI Tools</span>
              <span>
                {expandedSection === 'aiTools' ? <MdKeyboardArrowDown /> : <MdKeyboardArrowRight />}
              </span>
            </button>
            <ul
              className={`absolute left-0 mt-2 bg-gray-700 text-white rounded-md shadow-lg ${
                expandedSection === 'aiTools' ? 'block' : 'hidden'
              }`}
            >
              <li className="px-4 py-2 hover:bg-gray-600">
                <Link to="/aitools/chatbot">Ai Chatbot</Link>
              </li>
            </ul>
          </li>

          
        

          {/* Automation Tools */}
          <li className="relative group">
            <button
              className="flex items-center space-x-2 hover:underline"
              onClick={() => toggleSection('automationTools')}
            >
              <span>Automation Tools</span>
              <span>
                {expandedSection === 'automationTools' ? (
                  <MdKeyboardArrowDown />
                ) : (
                  <MdKeyboardArrowRight />
                )}
              </span>
            </button>
            <ul
              className={`absolute left-0 mt-2 bg-gray-700 text-white rounded-md shadow-lg ${
                expandedSection === 'automationTools' ? 'block' : 'hidden'
              }`}
            >
              <li className="px-4 py-2 hover:bg-gray-600">
                <Link to="/automation-tools/sample-generator">Sample Generator</Link>
              </li>

            </ul>
          </li>

{/* Automation Tools */}
<li className="relative group">
            <button
              className="flex items-center space-x-2 hover:underline"
              onClick={() => toggleSection('certifications')}
            >
              <span>Certifications</span>
              <span>
                {expandedSection === 'certifications' ? (
                  <MdKeyboardArrowDown />
                ) : (
                  <MdKeyboardArrowRight />
                )}
              </span>
            </button>
            <ul
              className={`absolute left-0 mt-2 bg-gray-700 text-white rounded-md shadow-lg ${
                expandedSection === 'certifications' ? 'block' : 'hidden'
              }`}
            >
              <li className="px-4 py-2 hover:bg-gray-600">
                <Link to="/certifications/cia">CIA</Link>
              </li>

            </ul>
          </li>

          <li>
            <Link to="/blog" className="hover:underline">
              Blog
            </Link>
          </li>
        </ul>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && (
        <div className="sm:hidden mt-4">
          <ul className="space-y-4">
            <li>
              <Link to="/" onClick={toggleMenu}>
                Home
              </Link>
            </li>

            {/* Resources */}
            <li>
              <button
                className="flex items-center w-full justify-between"
                onClick={() => toggleSection('resources')}
              >
                <span>Resources</span>
                <span>
                  {expandedSection === 'resources' ? (
                    <MdKeyboardArrowDown />
                  ) : (
                    <MdKeyboardArrowRight />
                  )}
                </span>
              </button>
              {expandedSection === 'resources' && (
                <ul className="pl-4 mt-2 space-y-2">
                  <li>
                    <Link to="/resources/audit-frameworks" onClick={toggleMenu}>
                      Audit Frameworks
                    </Link>
                  </li>

                  <li>
                    <Link to="/resources/workprograms" onClick={toggleMenu}>
                      Work Programs
                    </Link>
                  </li>
                  <li>
                    <Link to="/resources/risk-matrix" onClick={toggleMenu}>
                      Risk and Control Matrix
                    </Link>
                  </li>
                  <li>
                    <Link to="/resources/audit-templates" onClick={toggleMenu}>
                      Audit Templates
                    </Link>
                  </li>

                  <li>
                    <Link to="/resources/job-descriptions" onClick={toggleMenu}>
                      Job Descriptions
                    </Link>
                  </li>
                  <li>
                    <Link to="/resources/risk-library" onClick={toggleMenu}>
                    Business Cycle Risks Library
                    </Link>
                  </li>
                  <li>
                    <Link to="/resources/guided-toolkit" onClick={toggleMenu}>
                      Guided Toolkits
                    </Link>
                  </li>


  

  
  

                </ul>
              )}
            </li>

            {/* Learning */}
            <li>
              <button
                className="flex items-center w-full justify-between"
                onClick={() => toggleSection('learning')}
              >
                <span>Learning</span>
                <span>
                  {expandedSection === 'learning' ? (
                    <MdKeyboardArrowDown />
                  ) : (
                    <MdKeyboardArrowRight />
                  )}
                </span>
              </button>
              {expandedSection === 'learning' && (
                <ul className="pl-4 mt-2 space-y-2">
                  <li>
                    <Link to="/videos" onClick={toggleMenu}>
                      Videos
                    </Link>
                  </li>
                  <li>
                    <Link to="/podcasts" onClick={toggleMenu}>
                      Podcasts
                    </Link>
                  </li>
                  <li>
                    <Link to="/faqs" onClick={toggleMenu}>
                      Frequently Asked Questions
                    </Link>
                  </li>
                  <li>
                    <Link to="/gamified-learning" onClick={toggleMenu}>
                      Gamified Learning
                    </Link>
                  </li>


                </ul>
              )}
            </li>

                        {/* Continuous Auditing */}
                        <li>
              <button
                className="flex items-center w-full justify-between"
                onClick={() => toggleSection('continuous')}
              >
                <span>Continuous Auditing</span>
                <span>
                  {expandedSection === 'continuous' ? (
                    <MdKeyboardArrowDown />
                  ) : (
                    <MdKeyboardArrowRight />
                  )}
                </span>
              </button>
              {expandedSection === 'continuous' && (
                <ul className="pl-4 mt-2 space-y-2">
                  <li>
                    <Link to="/continuous" onClick={toggleMenu}>
                      Dashboards
                    </Link>
                  </li>


                </ul>
              )}
            </li>

            {/* AI Tools */}
            <li>
              <button
                className="flex items-center w-full justify-between"
                onClick={() => toggleSection('aiTools')}
              >
                <span>AI Tools</span>
                <span>
                  {expandedSection === 'aiTools' ? <MdKeyboardArrowDown /> : <MdKeyboardArrowRight />}
                </span>
              </button>
              {expandedSection === 'aiTools' && (
                <ul className="pl-4 mt-2 space-y-2">
                  <li>
                    <Link to="/aitools/chatbot" onClick={toggleMenu}>
                      Ai chatbot
                    </Link>
                  </li>
                </ul>
              )}
            </li>

            {/* Automation Tools */}
            <li>
              <button
                className="flex items-center w-full justify-between"
                onClick={() => toggleSection('automationTools')}
              >
                <span>Automation Tools</span>
                <span>
                  {expandedSection === 'automationTools' ? (
                    <MdKeyboardArrowDown />
                  ) : (
                    <MdKeyboardArrowRight />
                  )}
                </span>
              </button>
              {expandedSection === 'automationTools' && (
                <ul className="pl-4 mt-2 space-y-2">
                  <li>
                    <Link to="/automation-tools/sample-generator" onClick={toggleMenu}>
                      Sample Generator
                    </Link>
                  </li>

                </ul>
              )}
            </li>

             {/* Certifications */}
             <li>
              <button
                className="flex items-center w-full justify-between"
                onClick={() => toggleSection('certifications')}
              >
                <span>Certifications</span>
                <span>
                  {expandedSection === 'certifications' ? (
                    <MdKeyboardArrowDown />
                  ) : (
                    <MdKeyboardArrowRight />
                  )}
                </span>
              </button>
              {expandedSection === 'certifications' && (
                <ul className="pl-4 mt-2 space-y-2">
                  <li>
                    <Link to="/certifications/cia" onClick={toggleMenu}>
                     CIA
                    </Link>
                  </li>

                </ul>
              )}
            </li>


            <li>
              <Link to="/blog" onClick={toggleMenu}>
                Blog
              </Link>
            </li>
          </ul>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
